export const EhrInstanceKbVersion_CollectionName = 'ehr-instance-kb-version';
//# sourceMappingURL=consts.js.map